import { Attributes, ReactNode } from "react";
import styled, { css } from "styled-components";

type ExternalSectionProps = React.HtmlHTMLAttributes<Attributes> & {
  sectionClass?: string;
  children: ReactNode;
};

const ExternalSectionWrapper = styled.section<{ sectionClass?: string }>`
  padding: 4rem 3.2rem 8rem;
  font-family: "Pretendard", sans-serif;

  .page_top_header .txt_title {
    line-height: 2.6rem;
    font-size: 2.2rem;
    font-weight: 600;
  }

  .page_top_header .txt_desc {
    margin-top: 1.1rem;
    font-size: 1.4rem;
    line-height: 2.2rem;
  }

  ${(props) => props.sectionClass === "page_policy" && css``}
  ${(props) => props.sectionClass === "page_inquiry_end" && css``}
`;

const ExternalSection = ({ sectionClass, children }: ExternalSectionProps) => {
  return (
    <>
      <ExternalSectionWrapper sectionClass={sectionClass}>{children}</ExternalSectionWrapper>
    </>
  );
};

export default ExternalSection;
